export default __webpack_public_path__ + "static/media/07_Zajic_Hlavica-min.5c10f871.jpg";